var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kvass-file__custom-drop col middle"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.instance.multiple ? 'dragFilesOrDrop' : 'dragFileOrDrop', { extension: _vm.ext }))}}),(_vm.$slots.default)?_c('div',{staticClass:"mt-2"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }